import { engine } from '@play-co/timestep-core';
import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { downscale } from 'src/conf/scale';

export class BuddiesMVP extends View {
  constructor(opts: ViewOpts) {
    super({
      width: downscale(111),
      height: downscale(106),
      ...opts,
    });

    const image = new ImageScaleView({
      superview: this,
      image: 'assets/ui/buddies/common/mvp_badge.png',
      width: this.style.width,
      height: this.style.height,
      x: this.style.width / 2,
      y: this.style.height / 2,
      centerOnOrigin: true,
    });

    const tick = () => {
      image.style.scale = 1 + Math.sin(performance.now() * 0.01) * 0.1;
    };

    engine.subscribe('Tick', tick);

    this.addListener('ViewAdded', () => {
      engine.unsubscribe('Tick', tick); // Ensure we don't add multiple listeners
      engine.subscribe('Tick', tick);
    });

    this.addListener('ViewRemoved', () => {
      engine.unsubscribe('Tick', tick);
    });
  }
}
